var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDepositar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.178,
    height: 47.495,
    viewBox: "0 0 47.178 47.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #00404f;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 4px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Entrega",
    "data-name": "Icon Entrega",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_499",
    "data-name": "Caminho 499",
    className: "cls-1",
    d: "M47.678,22.5v9.6a4.8,4.8,0,0,1-4.8,4.8H9.3a4.8,4.8,0,0,1-4.8-4.8V22.5",
    transform: "translate(-4.5 6.602)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_500",
    "data-name": "Caminho 500",
    className: "cls-1",
    d: "M10.5,15l8.851,8.851L28.2,15",
    transform: "translate(2.238 1.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_501",
    "data-name": "Caminho 501",
    className: "cls-1",
    d: "M18,29.831V4.5",
    transform: "translate(3.589 -4.5)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositar);
export default __webpack_public_path__ + "static/media/Depositar.39f75d6df334f0d71eb41e28a6faa4b6.svg";
export { ForwardRef as ReactComponent };